/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OutboundOrder } from './OutboundOrder';
import {
    OutboundOrderFromJSON,
    OutboundOrderFromJSONTyped,
    OutboundOrderToJSON,
} from './OutboundOrder';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';

/**
 * 
 * @export
 * @interface OutboundOrderPagable
 */
export interface OutboundOrderPagable {
    /**
     * Array of items
     * @type {Array<OutboundOrder>}
     * @memberof OutboundOrderPagable
     */
    items?: Array<OutboundOrder>;
    /**
     * 
     * @type {Pageable}
     * @memberof OutboundOrderPagable
     */
    meta?: Pageable;
}

/**
 * Check if a given object implements the OutboundOrderPagable interface.
 */
export function instanceOfOutboundOrderPagable(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OutboundOrderPagableFromJSON(json: any): OutboundOrderPagable {
    return OutboundOrderPagableFromJSONTyped(json, false);
}

export function OutboundOrderPagableFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundOrderPagable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(OutboundOrderFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PageableFromJSON(json['meta']),
    };
}

export function OutboundOrderPagableToJSON(value?: OutboundOrderPagable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(OutboundOrderToJSON)),
        'meta': PageableToJSON(value.meta),
    };
}

